"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
//
// assets
//
const blankBackground_webp_1 = __importDefault(require("../../../assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("../HeroImage"));
const passwordRecoveryCopy_1 = require("../../../copy/passwordRecoveryCopy");
const queryDefinitions_1 = require("../../../queryDefinitions");
//
// components
//
const OnboardingForm_1 = __importDefault(require("../OnboardingForm"));
const GenericInput_1 = __importDefault(require("../../general/inputs/GenericInput"));
const FormValidation_1 = require("../../general/utility/FormValidation");
const loginCopy_1 = require("../../../copy/loginCopy");
//
// styles
//
const StyledImageBackground_1 = require("../styles/StyledImageBackground");
const linkProps = {
    preface: loginCopy_1.loginCopy.linkPreface,
    href: loginCopy_1.loginCopy.linkHref,
    prompt: loginCopy_1.loginCopy.linkPrompt
};
const PasswordRecovery = () => {
    const [email, setEmail] = (0, react_1.useState)('');
    const [emailError, setEmailError] = (0, react_1.useState)('');
    const [recoverPassword, { data, loading, error }] = (0, client_1.useMutation)(queryDefinitions_1.REQUEST_PASSWORD_RESET);
    function handleBlur(event) {
        const validationError = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (validationError) {
            setEmailError(validationError);
        }
        else {
            setEmailError('');
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'email') {
            setEmail(event.target.value);
        }
    }
    function handleRecovery(e) {
        e.preventDefault();
        recoverPassword({ variables: { input: { email: email } } });
    }
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'login', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: error, contactLink: linkProps, cta: data ? null : passwordRecoveryCopy_1.passwordRecoveryCopy.cta, header: passwordRecoveryCopy_1.passwordRecoveryCopy.header, inputs: data
                ? null
                : [
                    react_1.default.createElement(GenericInput_1.default, { error: emailError, id: 'email', key: 'email', label: passwordRecoveryCopy_1.passwordRecoveryCopy.input1, onBlur: handleBlur, onInputChange: handleInputChange })
                ], loading: loading, onFormSubmit: handleRecovery, textPrompt: data ? passwordRecoveryCopy_1.passwordRecoveryCopy.confirmation : passwordRecoveryCopy_1.passwordRecoveryCopy.prompt }),
        react_1.default.createElement(HeroImage_1.default, { header: passwordRecoveryCopy_1.passwordRecoveryCopy.heroHeader, subheader: passwordRecoveryCopy_1.passwordRecoveryCopy.heroSubHeader })));
};
exports.default = PasswordRecovery;
